import { createReducer, on } from '@ngrx/store';
import { ToothDetailsView } from '../components/tooth-details-dialog/tooth-details/tooth-details.vm';
import { chartingActions } from './charting.actions';

export interface ChartingState {
  lastToothPosition?: number;
  screen: 'charting' | 'perio';
  viewToggle: ToothDetailsView;
}

const initialState: ChartingState = {
  lastToothPosition: undefined,
  screen: 'charting',
  viewToggle: 'charting',
};

export const chartingReducer = createReducer(
  initialState,
  on(
    chartingActions.lastToothPositionChanged,
    (state, { toothPosition }): ChartingState => ({ ...state, lastToothPosition: toothPosition }),
  ),
  on(chartingActions.screenChanged, (state, { screen }): ChartingState => ({ ...state, screen })),
  on(chartingActions.viewToggleChanged, (state, { viewToggle }): ChartingState => ({ ...state, viewToggle })),
);
